import { render, staticRenderFns } from "./user-register.vue?vue&type=template&id=a61ed45a&scoped=true"
import script from "./user-register.vue?vue&type=script&lang=js"
export * from "./user-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61ed45a",
  null
  
)

/* custom blocks */
import block0 from "./user-register.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports